import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Preloader({ onFinish }) {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          setTimeout(() => {
            setVisible(false);
            if (onFinish) onFinish();
          }, 400);
          return 100;
        }
        // Accelerate near the end
        const increment = prev < 70 ? Math.random() * 8 + 3 : Math.random() * 4 + 1;
        return Math.min(prev + increment, 100);
      });
    }, 80);
    return () => clearInterval(interval);
  }, [onFinish]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="preloader"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: 1.05 }}
          transition={{ duration: 0.6, ease: "easeInOut" }}
        >
          {/* Ambient glow orbs */}
          <div className="preloader-orb preloader-orb-1" />
          <div className="preloader-orb preloader-orb-2" />

          <div className="preloader-content">
            {/* Spinning film reel */}
            <motion.div
              className="preloader-reel"
              animate={{ rotate: 360 }}
              transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" fill="none" viewBox="0 0 72 72">
                {/* Outer ring */}
                <circle cx="36" cy="36" r="34" stroke="#e7b816" strokeWidth="2.5" opacity="0.3" />
                <circle cx="36" cy="36" r="28" stroke="#e7b816" strokeWidth="1.5" opacity="0.15" />
                {/* Film holes */}
                <circle cx="36" cy="6" r="4" fill="#e7b816" opacity="0.9" />
                <circle cx="57.2" cy="14.8" r="4" fill="#e7b816" opacity="0.7" />
                <circle cx="66" cy="36" r="4" fill="#e7b816" opacity="0.9" />
                <circle cx="57.2" cy="57.2" r="4" fill="#e7b816" opacity="0.7" />
                <circle cx="36" cy="66" r="4" fill="#e7b816" opacity="0.9" />
                <circle cx="14.8" cy="57.2" r="4" fill="#e7b816" opacity="0.7" />
                <circle cx="6" cy="36" r="4" fill="#e7b816" opacity="0.9" />
                <circle cx="14.8" cy="14.8" r="4" fill="#e7b816" opacity="0.7" />
                {/* Center */}
                <circle cx="36" cy="36" r="8" fill="#e7b816" opacity="0.2" />
                <circle cx="36" cy="36" r="3" fill="#e7b816" />
              </svg>
            </motion.div>

            {/* Brand name */}
            <motion.h1
              className="preloader-title"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              ReelReviews
            </motion.h1>

            {/* Tagline */}
            <motion.p
              className="preloader-tagline"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.6 }}
              transition={{ delay: 0.7, duration: 0.5 }}
            >
              Real reviews by real cinephiles
            </motion.p>

            {/* Progress bar */}
            <div className="preloader-bar-track">
              <motion.div
                className="preloader-bar-fill"
                initial={{ width: "0%" }}
                animate={{ width: `${progress}%` }}
                transition={{ duration: 0.15, ease: "easeOut" }}
              />
            </div>

            <motion.span
              className="preloader-percent"
              initial={{ opacity: 0 }}
              animate={{ opacity: 0.4 }}
              transition={{ delay: 0.5 }}
            >
              {Math.round(progress)}%
            </motion.span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
